<template>
  <div @click.stop class="mobile-menu-wrapper">
    <transition name="slide-bottom">
      <section class="menu" v-if="showModal">
        <h1>{{ label }}</h1>

        <section class="actions-wrap">
          <div
            v-for="(action, index) of sortedActions"
            class="action"
            :key="`action-${index}`"
            :class="action.actionClass"
            @click.stop="select(action)"
          >
            <span class="mck" v-if="isSort && action.icon">{{
              action.icon
            }}</span>
            <p>{{ prop ? action[prop] : action }}</p>

            <span
              v-if="isSort && action.icon"
              class="mck"
              @click.stop="select({ ...action, remove: true })"
              >F</span
            >
          </div>

          <button class="btn" @click.stop="select()">ЗАТВОРИ</button>
        </section>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["value", "arr", "prop", "propValue", "isSort", "label"],
  computed: {},
  data() {
    return { showModal: false, sortedActions: [] };
  },
  methods: {
    getSortClass() {
      if (this.value && this.propValue) {
        this.sortedActions = this.arr.map((action) => {
          let actionClass = "";

          if (this.isSort) {
            let v = this.value[action[this.propValue]];

            let icon = "";

            if (v === 1) {
              icon = "3";
              actionClass = "action--asc";
            } else if (v === -1) {
              icon = "2";
              actionClass = "action--desc";
            }

            return {
              ...action,
              icon,
              actionClass,
            };
          } else {
            let v = this.value[this.propValue];

            if (action[this.propValue] === v) {
              actionClass = "action--active";
            }

            return {
              ...action,
              actionClass,
            };
          }
        });
      } else {
        this.sortedActions = this.arr.slice();
      }
    },
    select(v) {
      if (v) this.$emit("selected", v);
      else this.$emit("close");
    },
  },
  mounted() {
    this.getSortClass();
    setTimeout(() => {
      this.showModal = true;
    }, 500);
  },
};
</script>

<style scoped lang="scss">
.mobile-menu-wrapper {
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  cursor: default;
  display: flex;
  justify-content: center;
  height: 100%;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 10;

  .menu {
    align-items: center;
    background: #ffffff;
    border-radius: 20px 20px 0 0;
    display: flex;
    flex-direction: column;
    gap: 17px;
    height: fit-content;
    padding: 10px 5px;
    max-width: 500px;
    width: 100%;

    h1 {
      font-size: 16px;
    }

    .actions-wrap {
      display: flex;
      flex-direction: column;
      width: 100%;

      .action,
      .btn {
        align-items: center;
        background: #e7edf2;
        cursor: pointer;
        justify-content: center;
        display: flex;
        font-size: 20px;
        height: 50px;
        width: 100%;
      }

      .action {
        padding: 0 10px;

        > p {
          flex: 1;
          text-align: center;
        }

        &.action--desc {
          color: #ffffff;
          background: #4081ac;
        }
        &.action--asc {
          color: #ffffff;
          background: #406bac;
        }
        &.action--active {
          background: #adc0d1;
        }

        &:first-of-type {
          border-radius: 10px 10px 0 0;
        }
        &:last-of-type {
          border-radius: 0 0 10px 10px;
          margin-bottom: 10px;
        }
        &:not(:first-of-type) {
          border-top: 2px solid #c7d5de;
        }
      }

      .btn {
        background: #b8ccdc;
        color: #000000;
        margin: initial;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .mobile-menu-wrapper {
    .menu {
      max-width: initial;
    }
  }
}
</style>
